<template>
  <v-row>
    <v-col
      cols="12"
      :class="['text-center mb-12', {'mt-9': $vuetify.breakpoint.smAndUp}]"
    >
      <!-- <h1>Email me</h1> -->

      <CustomLink
      href="mailto:hi@stephenbeckett.co"
      :class="['mb-6 d-block', {'display-2': $vuetify.breakpoint.smAndUp, 'display-1': $vuetify.breakpoint.xsOnly}]"
      emoji
      confetti
      emojiShake
      >
      hi@stephenbeckett.co
      </CustomLink>

      <v-btn
        outlined
        fab
        x-large
        class="ma-1"
        href="https://twitter.com/StephenBeckett"
        target="_blank"
      >
        <v-icon>mdi-twitter</v-icon>
      </v-btn>
      <v-btn
        outlined
        fab
        x-large
        class="ma-1"
        href="https://www.linkedin.com/in/beckettstephen/"
        target="_blank"
      >
        <v-icon>mdi-linkedin</v-icon>
      </v-btn>
      <!-- <v-btn
        outlined
        fab
        x-large
        class="ma-1"
        href="https://github.com/stephenbeckett"
        target="_blank"
      >
        <v-icon>mdi-github-circle</v-icon>
      </v-btn> -->
    </v-col>
    <v-col
      cols="12"
    >
      <PortfolioList
          :num="4"
          :maxPerRow="4"
      >
      </PortfolioList>
    </v-col>
  </v-row>
</template>

<script>
import PortfolioList from '@/components/PortfolioList.vue'
import CustomLink from '@/components/CustomLink.vue'

export default {
    components: {
        PortfolioList,
        CustomLink
    },
    data: () => ({
    })
}
</script>